import * as React from "react";
const SvgTriangleRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 10, viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.5 10L5.5 5L0.5 0V10Z", fill: "#009299" }));
export default SvgTriangleRight;
